// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"df24dd73","487":"cf916f55"}[chunkId] + ".chunk.css";
};